import React, { useState, useEffect } from "react";
import Axios from "axios";
import { host } from "../App";
import "./Moulding_entry.css";

function Moulding_entry(props) {
  const token = window.localStorage.getItem("acessToken");
  const user = JSON.parse(window.localStorage.getItem("Name"));

  const [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [part_dataset, setpart_dataset] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState([
    { Po_No: "", Part_No: "", Po_Ship_Date: "", Part_Description: "", Customer: "", Qty: "", Po_Date: "", Comments: "" },
    { Po_No: "", Part_No: "", Po_Ship_Date: "", Part_Description: "", Customer: "", Qty: "", Po_Date: "", Comments: "" },
    { Po_No: "", Part_No: "", Po_Ship_Date: "", Part_Description: "", Customer: "", Qty: "", Po_Date: "", Comments: "" },
    { Po_No: "", Part_No: "", Po_Ship_Date: "", Part_Description: "", Customer: "", Qty: "", Po_Date: "", Comments: "" },
    { Po_No: "", Part_No: "", Po_Ship_Date: "", Part_Description: "", Customer: "", Qty: "", Po_Date: "", Comments: "" },
  ]);

  // keep clock updated
  useEffect(() => {
    const timer = setInterval(() => setDate1(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // load dataset
  useEffect(() => {
    Axios.get(`https://${host}/api/get/part_dataset/${token}`)
      .then((res) => setpart_dataset(res.data))
      .catch(() => setpart_dataset([]));
  }, [token]);

  // keep Date2 synced if needed later
  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Date2]);

  const submitValue = (e, index) => {
    const partNo = (e.target.value || "").trim();
    const found = part_dataset.find((x) => x.Part_No === partNo);

    const newData = [...data];
    newData[index].Part_No = partNo;

    if (found) {
      newData[index].Customer = found.Customer || "";
      newData[index].Part_Description = found.Part_Description || "";
    } else {
      // if part not found, keep fields blank (prevents crash)
      newData[index].Customer = "";
      newData[index].Part_Description = "";
    }

    setData(newData);
  };

  const addLines = () => {
    if (data.length < 15) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({
          Po_No: "",
          Part_No: "",
          Po_Ship_Date: "",
          Part_Description: "",
          Customer: "",
          Qty: "",
          Po_Date: "",
          Comments: "",
        });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit");
    }
  };

  const submitdata = () => {
    const filteredData = [];

    // IMPORTANT: confirm should not pop 10 times. Do it ONCE.
    let missingDatesFound = false;

    data.forEach((item) => {
      const touched = item.Po_No || item.Part_No;
      const missingDates = !item.Po_Ship_Date || !item.Po_Date;
      if (touched && missingDates) missingDatesFound = true;
    });

    if (missingDatesFound) {
      // eslint-disable-next-line no-restricted-globals
      const proceed = confirm("Some fields are missing (Po Ship Date or Po Date). Do you want to continue?");
      if (!proceed) return;
    }

    data.forEach((item) => {
      if (
        item.Po_No &&
        item.Part_No &&
        item.Customer &&
        item.Part_Description &&
        item.Po_Ship_Date &&
        item.Po_Date
      ) {
        filteredData.push([
          item.Po_No,
          item.Part_No,
          item.Po_Ship_Date,
          item.Part_Description,
          item.Customer,
          item.Qty,
          item.Po_Date,
          item.Comments,
          user,
        ]);
      }
    });

    setIsLoading(true);

    if (filteredData.length > 0) {
      setTimeout(() => {
        Axios.post(`https://${host}/api/moulding_entry`, { filteredData, user, token })
          .then((response) => {
            if (response.status === 200) {
              window.alert(response.data.message);
              setIsLoading(false);
              window.location.reload();
            } else {
              window.alert("Something went wrong.");
              setIsLoading(false);
            }
          })
          .catch(() => {
            window.alert("Error Occured");
            setIsLoading(false);
          });
      }, 700);
    } else {
      window.alert("Please fill all sections!");
      setIsLoading(false);
    }
  };

  return (
    <div className="me-page">
      <div className="me-toolbar">
        <div>
          <div className="me-kicker">PO Entry</div>
          <h2 className="me-title">Moulding Entry</h2>
          <div className="me-sub">Type Part No and it will auto-fill Customer + Description.</div>
        </div>

        <div className="me-actions">
          <button onClick={addLines} className="btn btn-success me-btn" type="button">
            Add Row
          </button>
          <button onClick={submitdata} className="btn btn-primary me-btn" type="button">
            Submit
          </button>
        </div>
      </div>

      <div className="me-card">
        <div className="me-tableWrap">
          <table className="table table-bordered me-table">
            <thead>
              <tr>
                <th>Po No</th>
                <th>Part No</th>
                <th>Po Ship Date</th>
                <th>Part Description</th>
                <th>Customer</th>
                <th>Qty</th>
                <th>Po Date</th>
                <th>Comments</th>
              </tr>
            </thead>

            <tbody>
              {data.map((line, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Po_No}
                      placeholder="Po No"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Po_No = e.target.value;
                        setData(newData);
                      }}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Part_No}
                      list="PartNo"
                      placeholder="Enter Part No"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Part_No = e.target.value;
                        setData(newData);
                      }}
                      onBlur={(e) => submitValue(e, index)}
                    />

                    <datalist id="PartNo">
                      <option></option>
                      {part_dataset.map((x) => (
                        <option key={x.Part_No}>{x.Part_No}</option>
                      ))}
                    </datalist>
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      value={data[index].Po_Ship_Date}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Po_Ship_Date = e.target.value;
                        setData(newData);
                      }}
                      required
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Part_Description}
                      placeholder="Part Description"
                      readOnly
                      required
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Customer}
                      placeholder="Customer"
                      readOnly
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Qty}
                      placeholder="Qty"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Qty = e.target.value;
                        setData(newData);
                      }}
                    />
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      value={data[index].Po_Date}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Po_Date = e.target.value;
                        setData(newData);
                      }}
                      required
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Comments}
                      placeholder="Comments"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Comments = e.target.value;
                        setData(newData);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {isLoading ? (
        <div className="me-overlay">
          <div className="me-loadingBox">
            <div className="me-dots">
              <span />
              <span />
              <span />
            </div>
            <div className="me-loadingText">Submitting…</div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Moulding_entry;
